export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE';
export const MODAL_OPEN  = 'MODAL_OPEN' ;
export const MODAL_CLOSE = 'MODAL_CLOSE';
export const MODAL_INIT  = 'MODAL_INIT' ;
export const INIT_MODAL_CALLBACK  = 'INIT_MODAL_CALLBACK' ;
export const CLEAR_MODAL_CALLBACK  = 'CLEAR_MODAL_CALLBACK' ;

// Resets the currently visible error message.
export const resetErrorMessage = () => ({
    type: RESET_ERROR_MESSAGE
});

export const doAlertModal = (modalStatus, modalMessage,modalRedirect) => (dispatch) => {

    let commonParams = {
        modalStatus: modalStatus,
        modalMessage: modalMessage,
        modalRedirect: modalRedirect
    }
    dispatch({
        type: MODAL_OPEN,
        commonParams: commonParams
    });
 }
 
 export const doCloseModal = (modalRedirect) => (dispatch) => {
    
    let commonParams = {
        modalStatus: false,
        modalMessage: null,
        modalRedirect: modalRedirect
    }

    dispatch({
        type: MODAL_CLOSE,
        commonParams: commonParams
    });
 }
 
 export const doInitModal = () => (dispatch) => {
    dispatch({
        type: MODAL_INIT,
    });
 }
 
 export const initModalCallback = (callback) => (dispatch) => {
    // callback is object
    // {
    //     initCallback: XXX
    //     closeCallback: XXX
    // }
 
    dispatch({
        type: INIT_MODAL_CALLBACK,
        commonParams: {
            callback: callback
        }
    });
 }
 
 export const clearModalCallback = () => (dispatch) => {
    dispatch({
        type: CLEAR_MODAL_CALLBACK
    });
 }